'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseCtaContainer = exports.PurchaseCtaUnwrapped = exports.mapDispatchToProps = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _purchase = require('containers/VenueDetail/purchase.saga');

var _multitrack = require('helpers/multitrack');

var _deep = require('helpers/deep');

var _BaseCta = require('./BaseCta');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = exports.mapDispatchToProps = {
  onClick: _purchase.showPurchaseModal
};

var PurchaseCtaUnwrapped = exports.PurchaseCtaUnwrapped = function PurchaseCtaUnwrapped(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      schedule = _ref.schedule,
      tooltip = _ref.tooltip;
  var scheduleId = schedule.id;

  var _deepExtract = (0, _deep.deepExtract)('availability.purchase', schedule, {}),
      currency = _deepExtract.currency,
      amount = _deepExtract.amount;

  var isDisabled = !(currency && amount);

  return _react2.default.createElement(
    _BaseCta.BaseCta,
    {
      className: (0, _classnames2.default)(className, {
        'bt--primary bt--outline': !isDisabled,
        'bt--disabled': isDisabled
      }),
      onClick: isDisabled ? undefined : function () {
        (0, _multitrack.ga)('Membership Purchase', 'alc_shopping_cta_click', scheduleId);
        onClick(scheduleId);
      },
      tooltipProps: tooltip ? { 'data-tooltip': tooltip } : null
    },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'schedule.row.alc-cta-reserve',
      defaultMessage: 'Reserve'
    }),
    !isDisabled && _react2.default.createElement(
      'span',
      { className: 'pl--' },
      _react2.default.createElement(_reactIntl.FormattedNumber, {
        id: 'schedule.row.alc-cta-reserve-$$',
        value: amount,
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0
      })
    )
  );
};

var PurchaseCtaContainer = exports.PurchaseCtaContainer = (0, _reactRedux.connect)(null, mapDispatchToProps)(PurchaseCtaUnwrapped);

PurchaseCtaUnwrapped.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired,
  schedule: _propTypes2.default.shape({
    id: _propTypes2.default.number.isRequired,
    availability: {
      purchase: {
        amount: _propTypes2.default.number.isRequired,
        currency: _propTypes2.default.string.isRequired
      }
    }
  }),
  tooltip: _propTypes2.default.string
};